<template>
    <div :class="[ $props.full ? 'rounded-lg' : 'rounded-t-lg']"
         class="relative bg-linear-to-r from-yellow-300 via-yellow-300 to-yellow-400 p-3"
    >
        <div class="relative flex justify-center sm:justify-start">
            <Link v-if="$props.href"
                  :href="$props.href"
                  class="text-base font-semibold uppercase tracking-wider text-yellow-900"
            >
                <slot />
            </Link>

            <span v-else
                  class="text-base font-semibold uppercase tracking-wider text-yellow-900"
            >
                <slot />
            </span>
        </div>
    </div>
</template>

<script setup>
import {Link} from '@inertiajs/vue3';
</script>

<script>
export default {
    props: {
        href: String,
        full: {
            type:    Boolean,
            default: false,
        },
    },
};
</script>